'use strict';

export default function removeEntities(value) {
    const decoder = document.createElement('textarea');

    decoder.innerHTML = value;

    if (decoder.childNodes.length === 0) {
        return '';
    }

    return decoder.childNodes[0].nodeValue;
}
